/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Settings_Billing_Cancel_DescriptionInputs */

const en_settings_billing_cancel_description = /** @type {(inputs: Settings_Billing_Cancel_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to cancel your ${i?.plan} subscription? You'll keep access until the end of the current billing period.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to cancel your {plan} subscription? You'll keep access until the end of the current billing period." |
*
* @param {Settings_Billing_Cancel_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_cancel_description = /** @type {((inputs: Settings_Billing_Cancel_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Cancel_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_cancel_description(inputs)
});
export { settings_billing_cancel_description as "settings.billing.cancel_description" }